﻿[
  {
    "name": "Argentina",
    "code": "ar",
    "rds_country": "ARGENTINA",
    "url_find": [
      {
        "type": "person",
        "domain": "AR_IDENTITY",
        "subDomain": "NATURAL_PERSON",
        "url_page": {
          "tkl": "/api/reactive/v1/MasterFile/ar/getPersonById",
          "gkl": "/api/v2/KL/getEntityById"
        },
        "field_dni": "documento_numero"
      },
      {
        "type": "company",
        "domain": "AR_IDENTITY",
        "subDomain": "LEGAL_ENTITY",
        "url_page": {
          "tkl": "/api/reactive/v1/MasterFile/ar/getCompanyById",
          "gkl": "/api/v2/KL/getEntityById"
        },
        "field_dni": "documento_numero"
      }
    ],
    "service": "gkl",
    "mail_contacto": "arnotas@equifax.com"
  },
  {
    "name": "Chile",
    "code": "cl",
    "url_find": [
      {
        "type": "person",
        "domain": "CL_CONSUMER_IDENTITY",
        "subDomain": "SRCEI_VERIFICATION",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/cl/getPersonById"
        },
        "field_dni": "rut"
      },
      {
        "type": "company",
        "domain": "CL_COMMERCIAL_IDENTITY",
        "subDomain": "BUSINESS_LINE",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/cl/getCompanyById"
        },
        "field_dni": "rut"
      },
      {
        "type": "persona_matrimonio",
        "domain": "CL_CONSUMER_IDENTITY",
        "subDomain": "MARRIAGE_CERTIFICATE",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/cl/getPersonMatriById"
        },
        "field_dni": "rut"
      }
    ],
    "service": "hash",
    "mail_contacto": ""
  },
  {
    "name": "Costa Rica",
    "code": "cr",
    "url_find": [
      {
        "type": "person",
        "domain": "CR_CONSUMER_IDENTITY",
        "subDomain": "OFFICIAL_REGISTER_TSE",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/cr/getPersonById"
        },
        "field_dni": "cedula"
      },
      {
        "type": "company",
        "domain": "CR_COMMERCIAL_IDENTITY",
        "subDomain": "OFFICIAL_REGISTER",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/cr/getCompanyById"
        },
        "field_dni": "cedula"
      },
      {
        "type": "person_immigrant",
        "domain": "CR_CONSUMER_IDENTITY",
        "subDomain": "IMMIGRANT_REGISTER",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/cr/getPersonImmigrantById"
        },
        "field_dni": "Identificacion"
      },
      {
        "type": "prop_mov_num_finca",
        "domain": "CR_PROPERTY",
        "subDomain": "MOVEMENT",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/cr/getPropertyMovementByNumFinca"
        },
        "field_dni": ""
      },
      {
        "type": "prop_lien_id_bien_inmueble",
        "domain": "CR_PROPERTY",
        "subDomain": "LIEN",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/cr/getPropertyLienByIdBienInmueble"
        },
        "field_dni": ""
      },
      {
        "type": "veh_mov_id_bien_mueble",
        "domain": "CR_VEHICLE",
        "subDomain": "MOVEMENT",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/cr/getVehicleMovementByIdBienMueble"
        },
        "field_dni": ""
      },
      {
        "type": "veh_lien_id_bien_mueble",
        "domain": "CR_VEHICLE",
        "subDomain": "LIEN",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/cr/getVehicleLienByIdBienMueble"
        },
        "field_dni": ""
      }
    ],
    "service": "hash",
    "mail_contacto": ""
  },
  {
    "name": "Ecuador",
    "code": "ec",
    "url_find": [
      {
        "type": "person",
        "domain": "",
        "subDomain": "",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/ec/getPersonById"
        },
        "field_dni": ""
      },
      {
        "type": "company",
        "domain": "",
        "subDomain": "",
        "url_page": {
          "hash": ""
        },
        "field_dni": ""
      }
    ],
    "service": "hash",
    "mail_contacto": ""
  },
  {
    "name": "El Salvador",
    "code": "sv",
    "url_find": [
      {
        "type": "person",
        "domain": "",
        "subDomain": "",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/sv/getPersonById"
        },
        "field_dni": ""
      },
      {
        "type": "company",
        "domain": "",
        "subDomain": "",
        "url_page": {
          "hash": ""
        },
        "field_dni": ""
      }
    ],
    "service": "gkl",
    "mail_contacto": ""
  },
  {
    "name": "Honduras",
    "code": "hn",
    "url_find": [
      {
        "type": "person",
        "domain": "",
        "subDomain": "",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/hn/getPersonById"
        },
        "field_dni": ""
      },
      {
        "type": "company",
        "domain": "",
        "subDomain": "",
        "url_page": {
          "hash": ""
        },
        "field_dni": ""
      }
    ],
    "service": "hash",
    "mail_contacto": ""
  },
  {
    "name": "Paraguay",
    "code": "py",
    "url_find": [
      {
        "type": "person",
        "domain": "PY_CONSUMER_IDENTITY",
        "subDomain": "NATURAL_PERSON",
        "url_page": {
          "gkl": "/api/v1/KL/getEntityById"
        },
        "field_dni": "documento"
      },
      {
        "type": "company",
        "domain": "PY_COMMERCIAL_IDENTITY",
        "subDomain": "LEGAL_ENTITY",
        "url_page": {
          "gkl": "/api/v1/KL/getEntityById"
        },
        "field_dni": "documento"
      }
    ],
    "service": "gkl",
    "mail_contacto": "py.procesos@equifax.com"
  },
  {
    "name": "Perú",
    "code": "pe",
    "url_find": [
      {
        "type": "person",
        "domain": "PE_CONSUMER_IDENTITY",
        "subDomain": "RENIEC_OFFICIAL_REGISTER",
        "url_page": {
          "gkl": "/api/v2/KL/getEntityById"
        },
        "field_dni": "documentNum"
      },
      {
        "type": "person_immigrant",
        "domain": "PE_CONSUMER_IDENTITY",
        "subDomain": "IMMIGRANT",
        "url_page": {
          "gkl": "/api/v2/KL/getEntityById"
        },
        "field_dni": "Identificacion"
      },
      {
        "type": "company",
        "domain": "PE_COMMERCIAL_IDENTITY",
        "subDomain": "SUNAT_BUSINESS_REGISTER",
        "url_page": {
          "gkl": "/api/v2/KL/getEntityById"
        },
        "field_dni": ""
      },
      {
        "type": "company_natural",
        "domain": "PE_COMMERCIAL_IDENTITY",
        "subDomain": "SUNAT_NATURAL_PERSON",
        "url_page": {
          "gkl": "/api/v2/KL/getEntityById"
        },
        "field_dni": ""
      }
    ],
    "service": "gkl",
    "mail_contacto": ""
  },
  {
    "name": "Rep. Dominicana",
    "code": "rd",
    "url_find": [
      {
        "type": "person",
        "domain": "DO_CONSUMER_IDENTITY",
        "subDomain": "JCE_REGISTRATION",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/rd/getPersonById"
        },
        "field_dni": "nationalId"
      },
      {
        "type": "company",
        "domain": "DO_COMMERCIAL_IDENTITY",
        "subDomain": "RNC_REGISTRATION",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/rd/getCompanyById"
        },
        "field_dni": "nationalId"
      },
      {
        "type": "vehicle",
        "domain": "DO_VEHICLE",
        "subDomain": "VHI_REGISTRATION",
        "url_page": {
          "hash": "/api/reactive/v1/MasterFile/rd/getVehiculoById"
        },
        "field_dni": "nationalId"
      }
    ],
    "service": "hash",
    "mail_contacto": ""
  },
  {
    "name": "Uruguay",
    "code": "uy",
    "rds_country": "URUGUAY",
    "url_find": [
      {
        "type": "person",
        "domain": "UY_IDENTITY",
        "subDomain": "NATURAL_PERSON",
        "url_page": {
          "tkl": "/api/reactive/v1/MasterFile/ar/getPersonById",
          "gkl": "/api/v2/KL/getEntityById"
        },
        "field_dni": "documento_numero"
      },
      {
        "type": "company",
        "domain": "UY_IDENTITY",
        "subDomain": "LEGAL_ENTITY",
        "url_page": {
          "tkl": "/api/reactive/v1/MasterFile/ar/getCompanyById",
          "gkl": "/api/v2/KL/getEntityById"
        },
        "field_dni": "documento_numero"
      }
    ],
    "service": "gkl",
    "mail_contacto": "arnotas@equifax.com"
  }
]
